import IpWhitelist from './ip-whitelist.page';

import { withLayout } from 'layout';

export default withLayout(IpWhitelist);
